export const TransactionFilterKey = {
    number_search: 'number_search',
    search: 'search',
    date_range: 'date_range',
    instruction_type: 'instruction_type', // Instructions
    sale_invoice_type: 'sale_invoice_type', // TYPE in Invoice
    sale_payment_type: 'sale_payment_type', // TYPE in Payment
    purchase_bill_type: 'purchase_bill_type', // TYPE in Purchase Bill
    purchase_payment_type: 'purchase_payment_type', // TYPE in Purchase Payment
    profit_summary: 'profit_summary', // TYPE in Report (Profit Summary)
    official_receipt_type: 'official_receipt_type', // TYPE in OR Report
    payment_voucher_type: 'payment_voucher_type', // TYPE in PV Report
    double_entry_type: 'double_entry_type', // TYPE in Double Entry Detail Report
    all_types: 'all_types', // TYPE in Report/All Transactions
    transaction_list_report_type: 'transaction_list_report_type', // TYPE in Transaction List Report
    contact_id: 'contact_id', // Bank
    customer_id: 'customer_id',
    supplier_id: 'supplier_id',
    supplier_employee_id: 'supplier_employee_id',
    sale_payment_mode: 'sale_payment_mode',
    purchase_payment_mode: 'purchase_payment_mode',
    status: 'status',
    email_status: 'email_status',
    transfer_status: 'transfer_status',
    custom_fields: 'custom_fields',
    account_id: 'account_id', // in payment/refund/banks
    pay_from_account_id: 'pay_from_account_id', // in payment/refund/banks
    deposit_to_account_id: 'deposit_to_account_id', // in payment/refund/banks
    number_format: 'number_format',
};
